const data = [
  { 
    id: 1,
    name: "Não liberado",
  },
  { 
    id: 2,
    name: "Liberado",
  },
];

export default [...data];
